module.exports = __webpack_public_path__ + "static/img/Header_1920x380-12.6d7cb77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/non-invasive-prenatal-paternity-test/Header_1920x380-12.jpg
// module id = FJ02
// module chunks = 0